import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { DialogTitle } from "../components/DialogTitle";
import { DialogContent } from "../components/DialogContent";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { TextLabel } from "../components/TextLabel";
import { ChipsReadonly } from "../components/ChipsReadonly";
import { Progress } from "../components/Progress";
import OrganizationName from "../containers/OrganizationName";
import { GlobalAccessCheckbox } from "../components/GlobalAccessCheckbox";

export const ExternalAppInfoDialog = ({
  onClose,
  onEdit,
  onDelete,
  app: {
    title,
    packageName,
    categories,
    description,
    iconUrl,
    doNotDelete,
    organizationRef,
    globalAccess,
    sortPriority=0
  },
  loading
}) => (
  <Dialog maxWidth="lg" scroll="body" onClose={onClose} open>
    <DialogTitle
      onEdit={onEdit}
      onDelete={onDelete}
      doNotDelete={doNotDelete}
      organizationRef={organizationRef}
      globalAccess={globalAccess}
    >
      External App: {title}
    </DialogTitle>
    <DialogContent>
      {loading && <Progress />}
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <TextLabel label="Title" value={title} />
          <TextLabel label="Package Name" value={packageName} />
          <br />
          <br />
          <ChipsReadonly
            data={categories}
            title="Categories"
          />
          <TextLabel label="Sort Priority" value={sortPriority} />
        </Grid>
        <Grid item xs={6}>
          <Typography variant="caption" display="block" gutterBottom>
            Icon
          </Typography>
          <img src={iconUrl} style={{ width: 100 }} />
        </Grid>
        <Grid item xs={12}>
          <TextLabel label="Description" value={description} />
          <OrganizationName organizationRef={organizationRef} />
          <GlobalAccessCheckbox value={globalAccess} readonly />
        </Grid>
      </Grid>
      <br />
    </DialogContent>
  </Dialog>
);
